import posOverview from "./tutorials/pos.overview.json";
import type {
  KnowledgebaseItem,
  KnowledgebaseLocale,
  LocalizedText,
  TrainingTutorial,
} from "./types";

export * from "./types";
export * from "./richText";
export * from "./tutorialVisibility";
export * from "./articleVisibility";
export * from "./version";

export const trainingTutorials: TrainingTutorial[] = [
  posOverview as TrainingTutorial,
];

export const knowledgebaseItems: KnowledgebaseItem[] = trainingTutorials.map(
  (tutorial) => ({
    ...tutorial,
    type: "training",
  }),
);

export const getTrainingTutorial = (id: string): TrainingTutorial | undefined =>
  trainingTutorials.find((tutorial) => tutorial.id === id);

export const localizeText = (
  text: LocalizedText,
  locale: string | KnowledgebaseLocale,
): string => text[locale as KnowledgebaseLocale] || text.en;
